(function () {
  function initVariantSync(scope) {
    var root = scope || document;
    var selects = root.querySelectorAll('.mc-case-variant-select');
    if (!selects.length) return;

    function syncSelects(source) {
      selects.forEach(function (select) {
        if (select !== source && select.value !== source.value) select.value = source.value;
      });
    }

    function updatePrice(select) {
      var option = select.options[select.selectedIndex];
      if (!option) return;
      var landing = select.closest('.mc-case') || document;
      landing.querySelectorAll('[data-mc-case-price]').forEach(function (el) {
        el.textContent = option.getAttribute('data-price') || el.textContent;
      });
      landing.querySelectorAll('[data-mc-case-compare]').forEach(function (el) {
        el.textContent = option.getAttribute('data-compare') || el.textContent;
      });
    }

    selects.forEach(function (select) {
      if (select.dataset.mcCaseReady === 'true') return;
      select.dataset.mcCaseReady = 'true';
      select.addEventListener('change', function () {
        syncSelects(select);
        updatePrice(select);
      });
    });
  }

  function initColorButtons(scope) {
    var root = scope || document;
    var buttons = root.querySelectorAll('[data-case-select]');
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      if (button.dataset.mcCaseReady === 'true') return;
      button.dataset.mcCaseReady = 'true';
      button.addEventListener('click', function () {
        var label = (button.getAttribute('data-case-select') || '').toLowerCase();
        var landing = button.closest('.mc-case') || document;
        var selects = landing.querySelectorAll('.mc-case-variant-select');
        var matchedValue = null;

        selects.forEach(function (select) {
          Array.prototype.slice.call(select.options).some(function (option) {
            var text = (option.textContent || '').toLowerCase();
            var title = (option.getAttribute('data-title') || '').toLowerCase();
            if (!option.disabled && (text.indexOf(label) !== -1 || title.indexOf(label) !== -1)) {
              matchedValue = option.value;
              return true;
            }
            return false;
          });
        });

        if (matchedValue) {
          selects.forEach(function (select) {
            select.value = matchedValue;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }

        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        button.classList.add('is-active');
      });
    });
  }

  function initReviewSliders(scope) {
    var root = scope || document;
    root.querySelectorAll('.mc-case-review-shell').forEach(function (shell) {
      if (shell.dataset.mcCaseReady === 'true') return;
      shell.dataset.mcCaseReady = 'true';
      var track = shell.querySelector('.mc-case-review-track');
      var prev = shell.querySelector('.mc-case-review-prev');
      var next = shell.querySelector('.mc-case-review-next');
      if (!track) return;

      function step() {
        var card = track.querySelector('.mc-case-review-card');
        return card ? card.getBoundingClientRect().width + 18 : 320;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  function initAll(scope) {
    initVariantSync(scope);
    initColorButtons(scope);
    initReviewSliders(scope);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
